export default "__VITE_ASSET__KoC7tidM__"